import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { SECTOR_TO_ICON } from '@cyberint/common-utils';
import { Tag, TagsContainer, TagVariants, CustomTooltip, Themes, Icons, COUNTRIES_OPTIONS } from '@cyberint/dsc';
import { campaignsT as t } from '@cyberint/common-campaigns';
import { EntityTag, EntityType } from '@cyberint/stateful-ui/ui/EntityTag';
import * as S from './styled';

export const CampaignNameCell = ({ renderedCellValue: campaignName }) => (
  <CustomTooltip title={campaignName} mode={Themes.LIGHT} maxWidth="220px">
    <div>
      <S.NameCell>{campaignName}</S.NameCell>
    </div>
  </CustomTooltip>
);

CampaignNameCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
  row: PropTypes.shape({}).isRequired
};

const CountryTag = ({ countryValue }) => {
  const { icon } = COUNTRIES_OPTIONS.find(c => c.value === countryValue) || {};
  return <Tag content={countryValue} icon={icon} variant={TagVariants.MAIN} />;
};

CountryTag.propTypes = {
  countryValue: PropTypes.string.isRequired
};

export const CountriesCell = ({ renderedCellValue: countries }) => {
  if (!countries || !countries?.length) return t('table.na');
  const chips = countries.map(c => <CountryTag countryValue={c} key={c} />);
  return <TagsContainer variant={TagVariants.MAIN} chips={chips} regularTooltip />;
};

CountriesCell.propTypes = {
  renderedCellValue: PropTypes.oneOfType([null, PropTypes.arrayOf(PropTypes.string)])
};

const SectorTag = ({ sector }) => {
  const iconName = SECTOR_TO_ICON[sector];
  const Icon = iconName && Icons[iconName];
  return <Tag content={sector} variant={TagVariants.MAIN} icon={Icon ? <Icon size={16} /> : null} />;
};

SectorTag.propTypes = {
  sector: PropTypes.string.isRequired
};

export const SectorsCell = ({ renderedCellValue: sectors }) => {
  if (!sectors || !sectors?.length) return t('table.na');
  const chips = sectors.map(s => <SectorTag key={s} sector={s} />);
  return <TagsContainer variant={TagVariants.MAIN} chips={chips} regularTooltip />;
};

SectorsCell.propTypes = {
  renderedCellValue: PropTypes.oneOfType([null, PropTypes.arrayOf(PropTypes.string)])
};

export const DateCell = ({ renderedCellValue: date }) =>
  date ? format(new Date(date), 'MMM dd, yyyy') : t('table.na');

DateCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired
};

export const MalwareCell = ({ renderedCellValue: value }) => {
  if (!value || !value.length) return t('table.na');
  const malwareChips = value.map(m => <EntityTag entity={m} key={m.id} type={EntityType.MALWARE} />);
  return <TagsContainer variant={TagVariants.MAIN} chips={malwareChips} regularTooltip />;
};

MalwareCell.propTypes = {
  renderedCellValue: PropTypes.oneOfType([null, PropTypes.arrayOf(PropTypes.object)])
};

export const ThreatActorsCell = ({ renderedCellValue: value }) => {
  if (!value || !value.length) return t('table.na');
  const threatActorsChips = value.map(ta => <EntityTag type={EntityType.THREAT_ACTOR} entity={ta} key={ta.id} />);
  return <TagsContainer variant={TagVariants.MAIN} chips={threatActorsChips} regularTooltip />;
};

ThreatActorsCell.propTypes = {
  renderedCellValue: PropTypes.oneOfType([null, PropTypes.arrayOf(PropTypes.object)])
};
